import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { stats, img, WHATSAPP } from '../mock';

const HERO_VIDEO = 'https://pub-573ad4f6a54444ab869af76eba4bf5b8.r2.dev/hero-video.mp4';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    // React does not reliably set the `muted` DOM property -> force it so
    // browsers allow autoplay without user gesture.
    v.muted = true;
    v.defaultMuted = true;
    const tryPlay = () => {
      const p = v.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    };
    tryPlay();
    v.addEventListener('canplay', tryPlay, { once: true });
    return () => v.removeEventListener('canplay', tryPlay);
  }, []);

  return (
    <section id="home" className="relative pt-[72px]">
      {/* Hero content */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[var(--uv-gold)]/[0.06] blur-[120px]" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pt-16 pb-10 text-center">
          <div className="inline-flex items-center px-5 py-2 rounded-full border border-[var(--uv-gold)]/50 mb-10 reveal">
            <span className="label-mono !text-[var(--uv-gold)]">Masterclass in italiano · Unreal Engine 5 · Archviz</span>
          </div>

          <h1 className="hero-title text-white text-[15vw] md:text-[9rem] lg:text-[11rem] mb-4 reveal">UNREAL VIZ</h1>

          <h2 className="font-display font-medium text-white text-3xl md:text-5xl lg:text-[3.5rem] leading-tight max-w-4xl mx-auto reveal">
            Il mercato dell&rsquo; Archviz, adesso &egrave; <span className="gold-text">Unreal Engine</span>
          </h2>

          <p className="mt-8 text-neutral-400 text-base md:text-lg max-w-2xl mx-auto leading-relaxed reveal">
            La Masterclass italiana per architetti, freelance e 3d Artist che vogliono imparare a produrre
            visualizzazioni ed esperienze fotorealistiche in tempo reale con Unreal Engine, il nuovo standard
            per la visualizzazione Architettonica
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 reveal">
            <a href={WHATSAPP} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[var(--uv-gold)] text-[#0c0c0e] font-semibold hover:bg-[var(--uv-gold-soft)] transition-colors">
              Accedi al corso
            </a>
            <a href="#programma"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full border border-white/25 text-white font-medium hover:border-[var(--uv-gold)] hover:text-[var(--uv-gold)] transition-colors">
              Inizia gratis — 3 lezioni subito <ArrowRight size={18} />
            </a>
          </div>
        </div>

        {/* Hero image */}
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pb-16 reveal">
          <div className="rounded-2xl overflow-hidden border border-white/10 aspect-[16/7] reveal-scale">
            <video
              ref={videoRef}
              className="w-full h-full object-cover"
              src={HERO_VIDEO}
              poster={img.hero}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              aria-label="Unreal Engine archviz showreel"
            />
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 border border-white/10 rounded-xl overflow-hidden">
          {stats.map((s, i) => (
            <div
              key={i}
              className={`py-12 px-6 text-center ${i !== 0 ? 'border-t lg:border-t-0 lg:border-l border-white/10' : ''} ${
                i === 2 ? 'border-t lg:border-t-0' : ''
              } ${i === 1 ? 'border-l' : ''}`}
            >
              <div className="font-display font-bold text-5xl md:text-6xl text-white">
                {s.value}
                {s.plus && <span className="gold-text"> +</span>}
                {!s.plus && s.value === 'UE5' ? null : null}
              </div>
              <div className="mt-3 text-sm text-neutral-400 uppercase tracking-wide">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
